package team.platforma.multiplatform_material_extension.util

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch

@Deprecated("")
@Composable
fun Modifier.verticalScrollbar(
    state: LazyListState,
    width: Dp = 4.dp,
    indicatorPadding: IndicatorPadding = IndicatorPadding(),
    showOnScrollProgress: Boolean = false,
    alpha: Float = .7f,
    color: Color = MaterialTheme.colorScheme.tertiary
): Modifier {

    val visibleItems = state.layoutInfo.visibleItemsInfo
    val totalItemCount = state.layoutInfo.totalItemsCount
    val isScrollAvailable = totalItemCount > visibleItems.size

    val targetAlpha =
        if (showOnScrollProgress ||!isScrollAvailable) if (state.isScrollInProgress) alpha else 0f else alpha

    val duration = if (showOnScrollProgress||!isScrollAvailable) if (state.isScrollInProgress) 150 else 1000 else 500


    val indicatorAlpha by animateFloatAsState(
        targetValue = targetAlpha,
        animationSpec = tween(durationMillis = duration)
    )

    val firstIndex by animateFloatAsState(
        targetValue = state.layoutInfo.visibleItemsInfo.firstOrNull()?.index?.toFloat() ?: 0f,
        animationSpec = spring(stiffness = Spring.StiffnessMediumLow)
    )

    val lastIndex by animateFloatAsState(
        targetValue = state.layoutInfo.visibleItemsInfo.lastOrNull()?.index?.toFloat() ?: 0f,
        animationSpec = spring(stiffness = Spring.StiffnessMediumLow)
    )



    return drawWithContent {
        drawContent()
        val itemsCount = state.layoutInfo.totalItemsCount


        if (itemsCount > 0) {
            val scrollbarTop =
                firstIndex / itemsCount * (size.height - 2 * indicatorPadding.vertical.toPx()) + indicatorPadding.vertical.toPx()
            val scrollBottom =
                (lastIndex + 1f) / itemsCount * (size.height - 2 * indicatorPadding.vertical.toPx()) + indicatorPadding.vertical.toPx()
            val scrollbarHeight = scrollBottom - scrollbarTop

            drawRoundRect(
                cornerRadius = CornerRadius(width.toPx() / 2, width.toPx() / 2),
                color = color,
                topLeft = Offset(
                    size.width - width.toPx() - indicatorPadding.horizontal.toPx(),
                    scrollbarTop
                ),
                size = Size(width.toPx(), scrollbarHeight),
                alpha = indicatorAlpha
            )
        }
    }
}

@Deprecated("")
@Composable
fun Modifier.verticalScrollbar2(
    state: LazyListState,
    width: Dp = 4.dp,
    indicatorPadding: IndicatorPadding = IndicatorPadding(),
    showOnScrollProgress: Boolean = false,
    alpha: Float = .7f,
    color: Color = MaterialTheme.colorScheme.tertiary
): Modifier {

    val isScrollAvailable = state.layoutInfo.totalItemsCount > state.layoutInfo.visibleItemsInfo.size

    val targetAlpha =
        if (showOnScrollProgress || !isScrollAvailable)
            if (state.isScrollInProgress) alpha else 0f
        else alpha

    val duration = if (showOnScrollProgress || !isScrollAvailable)
        if (state.isScrollInProgress) 150 else 1000
    else 500

    val indicatorAlpha by animateFloatAsState(
        targetValue = targetAlpha,
        animationSpec = tween(durationMillis = duration),
        label = "alphaAnim"
    )

    return drawWithContent {
        drawContent()

        val layoutInfo = state.layoutInfo
        val totalItems = layoutInfo.totalItemsCount
        val viewportHeight = size.height - 2 * indicatorPadding.vertical.toPx()

        if (totalItems > 0 && layoutInfo.visibleItemsInfo.isNotEmpty()) {
            val totalHeight = layoutInfo.visibleItemsInfo.sumOf { it.size }.toFloat() /
                    layoutInfo.visibleItemsInfo.size * totalItems

            val firstVisible = layoutInfo.visibleItemsInfo.first()
            val offsetY = state.firstVisibleItemIndex * firstVisible.size + state.firstVisibleItemScrollOffset
            val scrollProgress = offsetY / totalHeight

            val visibleItemsHeight = layoutInfo.visibleItemsInfo.sumOf { it.size }.toFloat()
            val scrollbarHeightPx = (visibleItemsHeight / totalHeight) * viewportHeight
            val scrollbarTopPx = scrollProgress * viewportHeight + indicatorPadding.vertical.toPx()

            drawRoundRect(
                color = color,
                topLeft = Offset(
                    size.width - width.toPx() - indicatorPadding.horizontal.toPx(),
                    scrollbarTopPx.coerceIn(0f, size.height - scrollbarHeightPx)
                ),
                size = Size(width.toPx(), scrollbarHeightPx),
                cornerRadius = CornerRadius(width.toPx() / 2),
                alpha = indicatorAlpha
            )
        }
    }
}

//@Composable
//fun Modifier.verticalScrollbar2(
//    state: LazyListState,
//    width: Dp = 4.dp,
//    indicatorPadding: IndicatorPadding = IndicatorPadding(),
//    showOnScrollProgress: Boolean = false,
//    alpha: Float = .7f,
//    color: Color = MaterialTheme.colorScheme.tertiary
//): Modifier = composed {
//
//    val coroutineScope = rememberCoroutineScope()
//
//    val indicatorAlpha by animateFloatAsState(
//        targetValue = if (showOnScrollProgress)
//            if (state.isScrollInProgress) alpha else 0f
//        else alpha,
//        animationSpec = tween(durationMillis = if (state.isScrollInProgress) 150 else 500),
//        label = "scrollbar-alpha"
//    )
//
//    // Анимируем положение вручную
//    val animatedScrollTop = remember { Animatable(0f) }
//    val animatedScrollHeight = remember { Animatable(0f) }
//
//    val layoutInfo = state.layoutInfo
//    val visibleItems = layoutInfo.visibleItemsInfo
//    val totalItems = layoutInfo.totalItemsCount
//
//    LaunchedEffect(visibleItems, totalItems) {
//        if (visibleItems.isEmpty() || totalItems == 0) return@LaunchedEffect
//
//        val first = visibleItems.first()
//        val viewportHeight = layoutInfo.viewportSize.height.toFloat()
//        val itemSize = first.size.toFloat()
//        val totalContentHeight = itemSize * totalItems
//
//        val scrollOffset = first.index * itemSize + first.offset
//        val scrollbarTop = (scrollOffset / totalContentHeight) * viewportHeight
//        val scrollbarHeight = (viewportHeight / totalContentHeight) * viewportHeight
//
//        launch {
//            animatedScrollTop.animateTo(
//                targetValue = scrollbarTop,
//                animationSpec = tween(durationMillis = 50, easing = LinearEasing)
//            )
//        }
//        launch {
//            animatedScrollHeight.animateTo(
//                targetValue = scrollbarHeight,
//                animationSpec = tween(durationMillis = 50, easing = LinearEasing)
//            )
//        }
//    }
//
//    drawWithContent {
//        drawContent()
//
//        if (totalItems == 0 || visibleItems.isEmpty()) return@drawWithContent
//
//        drawRoundRect(
//            color = color,
//            topLeft = Offset(
//                x = size.width - width.toPx() - indicatorPadding.horizontal.toPx(),
//                y = animatedScrollTop.value + indicatorPadding.vertical.toPx()
//            ),
//            size = Size(width.toPx(), animatedScrollHeight.value),
//            cornerRadius = CornerRadius(width.toPx() / 2),
//            alpha = indicatorAlpha
//        )
//    }
//}

@Deprecated("")
@Composable
fun Modifier.verticalScrollbar(
    scrollState: ScrollState,
    width: Dp = 4.dp,
    indicatorPadding: IndicatorPadding = IndicatorPadding(),
    showOnScrollProgress: Boolean = false,
    alpha: Float = .7f,
    color: Color = MaterialTheme.colorScheme.tertiary
): Modifier {

    val isScrollAvailable = scrollState.maxValue > 0

    val targetAlpha =
        if (showOnScrollProgress || !isScrollAvailable) {
            if (scrollState.isScrollInProgress) alpha else 0f
        } else alpha

    val duration = if (showOnScrollProgress || !isScrollAvailable) {
        if (scrollState.isScrollInProgress) 150 else 1000
    } else 500

    val indicatorAlpha by animateFloatAsState(
        targetValue = targetAlpha,
        animationSpec = tween(durationMillis = duration)
    )

    val scrollFraction = if (scrollState.maxValue > 0) {
        scrollState.value.toFloat() / scrollState.maxValue
    } else 0f

    return drawWithContent {
        drawContent()

        if (isScrollAvailable) {
            val scrollbarHeight = (size.height - 2 * indicatorPadding.vertical.toPx()) *
                    (size.height / (size.height + scrollState.maxValue))

            val scrollbarTop = scrollFraction *
                    (size.height - scrollbarHeight - 2 * indicatorPadding.vertical.toPx()) +
                    indicatorPadding.vertical.toPx()

            drawRoundRect(
                color = color,
                cornerRadius = CornerRadius(width.toPx() / 2),
                topLeft = Offset(
                    size.width - width.toPx() - indicatorPadding.horizontal.toPx(),
                    scrollbarTop
                ),
                size = Size(width.toPx(), scrollbarHeight),
                alpha = indicatorAlpha
            )
        }
    }
}

class IndicatorPadding(
    var horizontal: Dp = 8.dp,
    var vertical: Dp = 8.dp
)